import React, { FC, useEffect, useState } from 'react'
import { createPortal } from 'react-dom'
import { useLocation } from 'react-router-dom'
import './footer.css'

// UTILITIES
import { flatten } from '@utils/string-helper'
import * as Icons from '@icons'


interface Props {
    className?: string
    children?: React.ReactNode
    hidden?: boolean
    sticky?: boolean
}

const Input: FC<Props> = (props) => {
    const { className: classProps, children, hidden, sticky = true } = props
    const container = flatten("column-footer-container", { hidden, sticky }, classProps)
    const [ready, setIsReady] = useState(false)
    const { pathname } = useLocation()

    useEffect(() => {
        setIsReady(true)
        document.querySelector('footer.column-footer-container')?.setAttribute('class', container)
        return () => {
            document.querySelector('footer.column-footer-container')?.setAttribute('class', 'column-footer-container')
            setIsReady(false)
        }
    }, [container])

    const portalTarget = document.querySelector('footer.column-footer-container')
    
    if (!ready || !portalTarget) return null

    return createPortal((
        <>
            <div className="column-footer">{children}</div>
            {!['/sign-in', '/verify'].includes(pathname) && (
                <div className="footer-support-text">
                    <a onClick={() => window.open("tel:+18886254349")}>Have an issue? Contact Support <Icons.Phone tint="var(--splitcard-blue-500)" style={{ width: '0.9em', height: '0.9em', display: 'inline', verticalAlign: 'middle', transform: 'translateY(-1px)' }} /></a>
                </div>
            )}
        </>
    ), portalTarget)
}

const Outlet: FC<Props> = (props) => {
    const { className: classProps, hidden, sticky, children } = props
    const container = flatten("column-footer-container", { hidden, sticky }, classProps)

    return <footer className={container} children={children} />
}

export const ColumnFooter = { Input, Outlet }